'use client'

import { useRouter } from 'next/navigation'
import posthog from 'posthog-js'
import { useRef, useState } from 'react'

import { authClient } from '@/auth-client'

const LEARN_HREF = '/journey/lessons/1/learn'

// The landing door (guest-mode spec §9). With any session — real or guest —
// it only navigates: calling signIn.anonymous() under a real session would
// sign that user out into a new guest (the plugin does not refuse it).
// Without one it starts a guest session, records guest_started, and opens
// Lesson 1's Learn; on failure it falls back to the sign-in page.
export function GuestDoor({
    children,
    className,
}: {
    children: React.ReactNode
    className: string
}) {
    const router = useRouter()
    const [pending, setPending] = useState(false)
    const inFlight = useRef(false)

    const open = async () => {
        if (inFlight.current) return
        inFlight.current = true
        setPending(true)
        try {
            const { data, error } = await authClient.getSession()
            if (error) {
                router.push('/signin')
                return
            }
            if (data?.user) {
                router.push(LEARN_HREF)
                return
            }
            const result = await authClient.signIn.anonymous()
            if (result.error) {
                router.push('/signin')
                return
            }
            try {
                posthog.capture('guest_started')
            } catch {
                // analytics must never block the door
            }
            router.push(LEARN_HREF)
        } catch {
            router.push('/signin')
        } finally {
            inFlight.current = false
            setPending(false)
        }
    }

    return (
        <button
            type="button"
            onClick={() => void open()}
            disabled={pending}
            className={className}
        >
            {children}
        </button>
    )
}
